/* eslint-disable */
import axios from '../index'

const insert = (data) => {
  return axios.post('recall', data)
}

const api = { insert }


export default api;